import React from 'react'
import { useSelector } from 'react-redux'
import { Row, Col } from 'antd'
import moment from 'moment'
import { ApplicationState } from 'src/store'
import { Text } from 'src/components/Ant'
import * as CSS from './styles'

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R13Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))
  if (!header.length) {
    return null
  }
  const defaultInfo = ' - '

  const endedOn =
    moment.unix(header[0]?.ended_on).utc().format('DD/MM/YYYY') || defaultInfo
  const startedOn =
    moment.unix(header[0]?.started_on).utc().format('DD/MM/YYYY') || defaultInfo
  const participant = header[0]?.participant ?? ''
  return (
    <CSS.SectionHeader>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.13.header.participant">
            <span id="value">{participant}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.4.header.started-on">
            <span id="value">{startedOn}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col offset={16} span={8}>
          <Text colon id="header" title="web.report.4.header.ended-on">
            <span id="value">{endedOn}</span>
          </Text>
        </Col>
      </Row>
    </CSS.SectionHeader>
  )
}

export default SectionHeader
